import { render } from "./SunbedModal.vue?vue&type=template&id=624d0950&scoped=true"
import script from "./SunbedModal.vue?vue&type=script&lang=js"
export * from "./SunbedModal.vue?vue&type=script&lang=js"

import "./SunbedModal.vue?vue&type=style&index=0&id=624d0950&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624d0950"]])

export default __exports__